<template>
  <div class="loading-credentials">
    <img class="ball" :src="require('@/assets/onboarding/Ball-0.9s-200px.svg')">
    <div class="title">בודקים את הנתונים
      ובונים לך תזרים ראשון!</div>
    <div class="content">זה יכול לקחת עד דקה
      אבל בדרך כלל רק כמה שניות…</div>
  </div>
</template>

<script>

export default {
  name: 'LoadingCredentials',
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../scss/mixins';

  .loading-credentials {
    @include responsive-padding;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .ball {
      width: 80%;
      margin-top: 20px;
    }

    .title {
      @include title();
      font-weight: bold;
      margin-bottom: 16px;
      line-height: 1.3em;
      white-space: pre-wrap;
    }

    .content {
      font-size: 18px;
      line-height: 24px;
      white-space: pre-wrap;
    }
  }
</style>
